import { Navigate } from "react-router-dom"
import { useContext } from "react"
import { AuthContext } from "../context/auth/AuthProvider"

const PrivateAdminRouter = ({ children }) => {

    const { client } = useContext(AuthContext)

    if (!client || client.rol !== "Admin") {
        return <Navigate to="/" replace />
    }

    return children
}

export default PrivateAdminRouter